<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title title="Rematch with AI" :show-dismiss="true" />
    <div class="t dark-gray">Tell Donut what to change and it'll suggest a new set of matches. Your saved matches stay put, and you can review every pairing before saving.</div>
    <div class="t m-tx3">
      <span class="bold">What should it do differently?</span>
      <span class="dark-gray m-l">(optional)</span>
    </div>
    <donut-input-text
      v-model="adminContext"
      class="m-tx1"
      :textarea="true"
      :autogrow="true"
      :wysiwyg="false"
      :max-length="1000"
      placeholder="e.g. Weight shared career goals most heavily, and pair early-career mentees with more senior mentors."
    />
    <donut-modal-sections-actions
      button-text="Rematch"
      :save-function="runRematch"
    />
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { useStore } from 'vuex';

  const { state, dispatch } = useStore();

  const adminContext = ref('');

  const runRematch = () => {
    dispatch('onboardingEnrollmentResponses/proposeMatches', {
      triggerUrl: state.modal.data.triggerUrl,
      pollUrl: state.modal.data.pollUrl,
      rematch: true,
      adminContext: adminContext.value,
    });
  };
</script>
